

exports.__esModule = true;
exports.$xoOnboardingSectionComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('../guestThrottle');

require('xo-wallet-components/src/fi-logos/directive');

var _squid = require('squid');

var _paypalplus = require('../paypalplus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoOnboardingSectionComponent = exports.$xoOnboardingSectionComponent = _squid.$Component.extend('$xoOnboardingSectionComponent', {
    tag: 'xo-onboarding-section',
    template: _template2['default'],
    scope: {
        token: '=',
        isWps: '=',
        guestVariant: '='
    },

    controller: function controller($scope, $guestThrottle, $locale, $populate, $FlowEligibilityModel, $feature, $CheckoutAppDataModel, $state) {

        function throttleOnboardingFlow(flow) {
            return $guestThrottle(flow, $scope.token, $locale.lang, $locale.country);
        }

        $scope.signupThrottle = function () {
            if ($scope.checkoutAppData.is_second_button_txn) {
                $state.go('checkout.redirectToCape');
            } else {
                throttleOnboardingFlow('signup');
            }
        };

        $scope.guestThrottle = function () {
            throttleOnboardingFlow('guest');
        };

        $populate($scope, {
            flowEligibility: $FlowEligibilityModel.instance($scope.token),
            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
        }).then(function () {
            var useForcedSignupFlow = (0, _paypalplus.$isPayPalPlus)($scope.token) || $scope.checkoutAppData.is_second_button_txn;
            var wps = $scope.isWps;
            var guest = $scope.flowEligibility.guest;
            var signup = $scope.flowEligibility.signup;

            $scope.showGuestBtn = !useForcedSignupFlow && (wps || guest);
            $scope.showSignupBtn = useForcedSignupFlow || !wps && !guest && signup;
            $scope.hideOrSeparator = !$scope.showGuestBtn && !$scope.showSignupBtn;
        });
    }
});

angular.value("$xoOnboardingSectionComponent", $xoOnboardingSectionComponent);
_squid.$Component;

_paypalplus.$isPayPalPlus;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-login/onboarding/directive.js
 ** module id = 178
 ** module chunks = 1
 **/